import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { ListApi } from './common/list';

export class FirstClickApi extends ListApi {
    public change(q: QuestionContext, evt: ResponseEventParams): void {
        const { value } = evt;
        const { responseActor, id } = q;
        responseActor.send({ type: 'CHANGE', value, questionId: id });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { id, clicks, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;

        if (value === CANTRATE_ID) {
            return {
                question: id,
                data: [{ cantRate: true, bool: true }],
                comment,
            };
        }

        return {
            question: id,
            data: clicks.map((click, idx) => ({
                answer: click.answerId,
                int: idx + 1,
                time: click.timeInMs,
                json: {
                    x: click.x,
                    y: click.y,
                },
            })),
            comment,
        };
    }

    public validate(question: QuestionContext): boolean {
        const {
            clicks,
            params: { required },
            responseActor,
        } = question;
        const { value } = responseActor.getSnapshot().context;

        if (!required || value === CANTRATE_ID) return true;

        return clicks.length > 0;
    }
}
